<template>
  <!-- This example requires Tailwind CSS v2.0+ -->



    <!--  новый футер на три колонки  -->

  <footer
    class="border-t border-gray-200 py-8 bg-white"
    aria-labelledby="footerHeading"
  >
    <h2 id="footerHeading" class="sr-only">Footer</h2>
    <div class="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:py-16 lg:px-8">
      <div class="xl:grid xl:grid-cols-3 xl:gap-8">

        <div
          class="mt-12 grid grid-cols-1 gap-8 text-center xl:text-left xl:mt-0 xl:col-span-3"
        >
          <div class="md:grid md:grid-cols-3 md:gap-8">
            <div style="text-align: center;">
              <h3
                class="text-sm font-semibold text-gray-400 tracking-wider uppercase"
              >
                Образовательная платформа
              </h3>
              <ul class="mt-4 space-y-4">
                <li>
                  <router-link class="text-base text-gray-500 hover:text-gray-900" :to="{ name: 'about' }">О проекте</router-link>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0" style="text-align: center;">
              <h3
                class="text-sm font-semibold text-gray-400 tracking-wider uppercase"
              >
                Сообщество
              </h3>
              <ul class="mt-4 space-y-4">
                <li>
                  <router-link class="text-base text-gray-500 hover:text-gray-900" :to="{ name: 'students' }">Учащиеся</router-link>
                </li>

                <li>
                  <router-link class="text-base text-gray-500 hover:text-gray-900" :to="{ name: 'partners' }">Партнёры</router-link>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0" style="text-align: center;">
              <h3
                class="text-sm font-semibold text-gray-400 tracking-wider uppercase"
              >
                Разное
              </h3>
              <ul class="mt-4 space-y-4">
                <li>
                  <router-link class="text-base text-gray-500 hover:text-gray-900" :to="{ name: 'help' }">Помощь</router-link>
                </li>
                <li>
                  <router-link class="text-base text-gray-500 hover:text-gray-900" :to="{ name: 'contacts' }">Контакты</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 mt-12 border-t border-gray-200 pt-8">
      <p class="text-base text-gray-400 text-center">
        &copy; 2021 Онлайн курсы, Фонд доказательной медицины. Все права защищены.
      </p>
    </div>
  </footer>
</template>
<script>
export default {};
</script>

